<template>
  <div id="app">
    <router-view v-if="isMobile&&!isEvaluate" name="MobIndex"/>
    <router-view v-else-if="isMobile&&isEvaluate" name="Evaluate"/>
    <div v-else style="height: 100%;
width: 100%;position: relative;">
      <router-view v-if="alone != 1" name="default"/>
      <router-view v-else name="PCFullScreenIndex"/>
      <!-- <div v-else class="framePage">
        <router-view/>
      </div> -->
    </div>

  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      FENBOT_fingerprint_from_jsapi: '',
      cid: '',
      alone: '',
      toid: '',
      csid: '',
      uid: '',
      type: '',
      source: '',
      consult: '',
      consultLink:'',
      isEvaluate:false, // 判断当前是否是评价页面
    }
  },
  computed: {
    loginInfo () {
      return this.$store.state.loginInfo
    },
    isMobile () {
      return this.$store.state.isMobile
    }
  },
  created () {
    console.log(this.$route)
    let curr_hash = this.$route.hash
    if(curr_hash.indexOf('/evaluate') > -1) {
      this.isEvaluate = true
    }

    let cid = this.$utils.GetQueryString('cid')
    let FENBOTFingerprint = this.$utils.GetQueryString('FENBOT_fingerprint')
    let alone = this.$utils.GetQueryString('alone')
    this.cid = cid || ''
    this.FENBOT_fingerprint_from_jsapi = FENBOTFingerprint || ''
    this.toid = this.$utils.GetQueryString('toid')
    this.csid = this.$utils.GetQueryString('csid')
    this.uid = this.$utils.GetQueryString('uid')
    this.type = this.$utils.GetQueryString('type')
    this.source = this.$utils.GetQueryString('source')
    this.consult = this.$utils.GetQueryString('consult')
    this.consultLink = this.$utils.GetQueryString('consultLink')
    this.alone = alone
    this.login()
    this.$store.dispatch('_deviceJudge')
  },
  mounted () {
    if (this.source === 'mmk') {
      var script = document.createElement("script")
        script.id = "mmk_src";
        script.type = "text/javascript";
        script.src = 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js';
        document.getElementsByTagName("head")[0].appendChild(script);
      var script_code = document.createElement("script")
        script_code.id = "mmk_text";
        script_code.type = "text/javascript";
        script_code.text = `
          var userAgent = navigator.userAgent;
            if (userAgent.indexOf('AlipayClient') > -1) {
                //  支付宝小程序的  JS-SDK  防止  404  需要动态加载，如果不需要兼容支付宝小程序，则无需引用此  JS  文件。
                document.writeln('<script  src="https://appx/web-view.min.js"' + '>' + '<' + '/' + 'script>');
            } else if (/QQ/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
                //  QQ  小程序
                document.write('<script  type="text/javascript"  src="https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js"><\/script>');
            } else if (/miniProgram/i.test(userAgent)) {
                //  微信小程序  JS-SDK  如果不需要兼容微信小程序，则无需引用此  JS  文件。
                document.write('<script  type="text/javascript"  src="https://res.wx.qq.com/open/js/jweixin-1.4.0.js"><\/script>');
            } else if (/toutiaomicroapp/i.test(userAgent)) {
                //  头条小程序  JS-SDK  如果不需要兼容头条小程序，则无需引用此  JS  文件。
                document.write('<script  type="text/javascript"  src="https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js"><\/script>');
            } else if (/swan/i.test(userAgent)) {
                //  百度小程序  JS-SDK  如果不需要兼容百度小程序，则无需引用此  JS  文件。
                document.write('<script  type="text/javascript"  src="https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.18.js"><\/script>');
            }
            if (!/toutiaomicroapp/i.test(userAgent)) {
                document.querySelector('.post-message-section').style.visibility = 'visible';
            }
        `;
        document.getElementsByTagName("head")[0].appendChild(script_code);
    }
    eventBus.$on('addrConfirm', () => {
      this.login()
    })
  },
  beforeDestroy() {
    eventBus.$off('addrConfirm')
  },
  methods: {
    // isMobile () {
    //   if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    /**
       * 浏览器指纹信息
       * @returns {string}
       */
    generateUnicode () {
      let FENBOTfingerprint = ''
      // 如果是通过jsapi访问，则使用jsapi传过来的指纹
      if (this.FENBOT_fingerprint_from_jsapi.length > 0) {
        FENBOTfingerprint = this.FENBOT_fingerprint_from_jsapi
      } else {
        FENBOTfingerprint = this.$cookie.get('FENBOT_fingerprint')

        if (typeof FENBOTfingerprint === 'undefined') {
          FENBOTfingerprint = new Date().getTime()
        }
      }

      this.$cookie.set('FENBOT_fingerprint', FENBOTfingerprint, { expires: 365, path: '/' })
      this.$cookie.set('cid', this.cid, { expires: 365, path: '/' })
      return FENBOTfingerprint
    },
    login () {
      let params = {
        cid: this.cid,
        uniquecode: this.generateUnicode(),
        toid: this.toid,
        csid: this.csid,
        uid: this.uid,
        type: this.type,
        source: this.source,
        consult: this.consult ? decodeURI(this.consult) : '',
        consultLink: this.consultLink ? this.consultLink : '',
      }
      this.$store.dispatch('_login', params)
      this.$store.dispatch('_getInitial', this.cid)
    }
  }
}
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-width: 320px;
    height: 100%;
    // .framePage{
    //   border: 0;
    //   padding: 0;
    //   float: none;
    //   background: 0 0;
    //   position: absolute;
    //   top: 5%;
    //   left: 50%;
    //   width: 504px;
    //   height: 90%;
    //   min-width: 504px;
    //   min-height: 410px;
    //   margin: 0 0 0 -252px;
    //   box-shadow: 0 0 20px 0 rgba(0,0,0,.15);
    // }
    .reply-operate{
      display: flex;
      justify-content: space-around;
      padding: 10px 15px 3px;
      text-align: center;
      border-top: 1px solid #eee;
      margin-top: 5px;
      color: #666;

      p{
        cursor: pointer;
        color: #428efe;
        padding: 0 15px;
      }
    }
  }
  .visitorAddressDialog{
    .van-action-sheet__content{
      max-height: 60vh;
      overflow-y: auto;
    }
    .van-radio-group{
      padding: 0 15px 40px;
      box-sizing: border-box;
      .van-radio__label{
        width: calc(100% - 28px);
      }
    }
    .confirmBtn{
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      line-height: 40px;
      text-align: center;
      background-color: #428efe;
      color: #fff;
      font-size: 14px;
    }
    .van-radio{
      padding: 18px 0;
      box-sizing: border-box;
    }
    .van-radio + .van-radio{
      border-top: 1px solid #eee;
    }
    .addressItemContainer{
      font-size: 13px;
      .userInfo{
        width: 100%;
        padding-bottom: 6px;
        font-size: 14px;
        color: #666;
      }
      .userName{
        float: left;
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 5px;
        box-sizing: border-box;

      }
      .userMobile{
        float: right;
        width: 50%;
        padding-left: 5px;
        text-align: right;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
      }
    }
  }
</style>
